import React, { useEffect, useState } from 'react'
import CustomTable from '../../../../Components/custom_components/CustomTable/CustomTable'
import CustomBottomPagination from '../../../../Components/custom_components/CustomBottomPagination/CustomBottomPagination'
import { handlePaginationEntries } from '../../../../utils/pagination'
import { ErrorToast, SuccessToast } from '../../../../utils/toast'
import Loader from '../../../../Components/Loader/Loader'
import CustomConfirmModal from '../../../../Components/custom_components/CustomConfirmModal/CustomConfirmModal'
import { get_all_bin_schedule_reports_with_pagination, get_all_completed_schedule_reports_with_pagination, get_all_completed_schedule_reports_without_pagination, reports_accept, schedule_move_to_client, schedule_move_to_finance } from '../../../../config/ScheduleReportApis/scheduleReportApis'
import BinReportSearchFilter from '../BinReportSearchFilter/BinReportSearchFilter'
import CustomLegend from '../../../../Components/custom_components/CustomLegend/CustomLegend'

function BinReportTable() {

    // State variables for managing schedule data, pagination, and modal states
    const [scheduleListing, setScheduleListing] = useState([]);
    const [pageNumber, setPageNumber] = useState(1);
    const [totalItemPerPage, setTotalItemPerPage] = useState(25);
    const [totalPages, setTotalPages] = useState(0);
    const [pagination, setPagination] = useState({ start: 0, end: 0, totalEntries: 0 });


    const [filterValues, setFilterValues] = useState({
        // reportName: '',
        // startDate: '',
        // endDate: '',
        // scheduleCode: '',
        // technology: '',
        // worksite: '',
        // project: '',
        // status: ''
    }); // Define filter values state

    const [isLoading, setIsLoading] = useState(false); // Loader state
    const [refresh, setRefresh] = useState(false);


    // const [selectedIds, setSelectedIds] = useState([]); //FOR FORWARD THE SCHEDULES ID INTO FINANCE


    // Fetch schedule data on page change or refresh
    useEffect(() => {
        CompeltedSchedulereports();
    }, [pageNumber, totalItemPerPage, filterValues]);

    // Fetch schedule data from API
    const CompeltedSchedulereports = async () => {
        const formData = new FormData();
        formData.append('page', pageNumber);
        formData.append('pageItemcount', totalItemPerPage);

        Object.keys(filterValues).forEach(key => formData.append(key, filterValues[key]));
        try {
            setIsLoading(true)
            const response = await get_all_bin_schedule_reports_with_pagination(formData);

            if (response?.status === "success") {
                const data = response.data;
                setScheduleListing(data?.data);
                setTotalPages(data.last_page);
                setPagination(handlePaginationEntries(data.from, data.to, data.total));
            } else {
                setScheduleListing([]);
            }
        } catch (error) {

        } finally {
            setIsLoading(false)
        }
    };

    // Columns for the table
    const columns = [
        { title: "#", key: "key" },
        { title: "Report ", key: "Reportname" },
        { title: "Schedule", key: "scheduleCode" },
        { title: "Worksite", key: "ScheduleWorksite" },
        { title: "Project", key: "projectName" },
        { title: "Technology ", key: "technologyname" },
        { title: "Created Date", key: "submitedDate" },
        { title: "Current Process", key: "process_status" },

        // { title: "To", key: "ReportEndDate" },

    ]

    // Map the schedule data into table rows
    const rows = () => scheduleListing?.map((item, index) => ({
        key: pageNumber * totalItemPerPage - (totalItemPerPage - (index + 1)),
        id: item.SHRD_Id,
        Reportname: item.report_name,
        technologyname: item?.technology,
        scheduleCode: item.scheduleCode,
        submitedDate: item?.submitedDate,
        process_status: item.process_status,
        projectName: item.projectName,
        ScheduleWorksite: item.worksite,

        ReportEndDate: item?.ReportEndDate,
        scheduleIsAccept: item?.SHRD_is_accept,



    }));

    // reports forward to client
    const handleReportsAccept = async () => {

        // const params = {
        //     scheduleReport: JSON.stringify(selectedIds), //  submitModal?.id
        //     is_accept: 1,
        //     scheduleID: ''
        // }
        // console.log("params", params);

        // try {
        //     const response = await reports_accept(params)
        //     if (response?.data?.status === "success") {
        //         SuccessToast(response?.data?.message)
        //         setRefresh(!refresh)
        //         setSelectedIds([]) //clear tge selected id after successfull forward
        //         handlSubmitModal(false, "")
        //     } else {
        //         ErrorToast(response?.data?.message || `Something Went Wrong!`)
        //         // }
        //     }
        // } catch (error) {

        // }

    }

    // Handle pagination changes
    const handlePageChange = (pageNumber) => setPageNumber(pageNumber);
    const handleItemPageCountChange = (pageItemCount) => setTotalItemPerPage(pageItemCount);

    // Handle search filter changes and update filter values
    const handleSearchFilter = (filterValues) => {
        setFilterValues(filterValues);
    };

    // FOR LEGND
    const BinLegend = [{ color: "#006CB8", label: "Accepted" },];
    return (
        <>
            <div className='workforce-management-table-container'>
                <BinReportSearchFilter
                    tableTitle={`Report Bin`}
                    searchFilter={handleSearchFilter}
                    on_change_value={handlePageChange}
                    on_page_count_update={handleItemPageCountChange}

                />
                <div>
                    <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '10px' }}>
                        <CustomLegend customeLegendItems={BinLegend} />
                    </div>
                    <CustomTable
                        columns={columns}
                        rows={isLoading ? [] : rows()}
                        isCheckbox={false} // showCheckBox && rows()?.length > 0 not show the select all check  box when no data
                        isLoading={isLoading}
                    />
                </div>
                <div className='bottom-container'>
                    {isLoading ? <Loader /> : <CustomBottomPagination
                        items_per_page={totalItemPerPage}
                        current_page={pageNumber}
                        total_page_count={totalPages}
                        on_change_value={handlePageChange}
                        on_page_count_update={handleItemPageCountChange}
                        pagination={pagination}
                    />}
                </div>
            </div>

            {/* <CustomConfirmModal
                custom_text={'Want to submit this to the Finance Department?'}
                open_modal={submitToFinance?.isOpen}
                close_modal={handlSubmitTofinanceModal}
                confirm_function={handleForwardToFinance}
            />

            <CustomConfirmModal
                custom_text={'Want to submit this to the Client?'}
                open_modal={submitModal?.isOpen}
                close_modal={handlSubmitModal}
                confirm_function={handleReportsAccept}
            /> */}
        </>
    )
}

export default BinReportTable